/* eslint-disable no-unused-vars */
import { Link } from "react-router-dom";
import NoticeManagementContainer from "../pages/noticeManagement/noticeManagementContainer";
import NoticeManagementNewContainer from "../pages/noticeManagementNew/noticeManagementNewContainer";
/**
 * Imports the necessary components and containers for the application's routing.
 * @module RoutingComponents
 * @requires react-router-dom
 * @requires NoticeManagementContainer
 * @requires DepotsManagementContainer
 * @requires UsersManagementContainer
 * @requires NoticeTypeContainer
 * @requires LoginContainer
 * @exports {Link} - The Link component from react-router-dom.
 * @exports {NoticeManagementContainer} - The container component for the NoticeManagement page.
 * @exports {DepotsManagementContainer} - The container component for the DepotsManagement page.
 * @exports {UsersManagementContainer} - The container component for the UsersManagement page.
 * @exports {NoticeTypeContainer} - The container component for the NoticeType page
 */
import DepotsManagementContainer from "../pages/depotsManagement/depotsManagementContainer";
import UsersManagementContainer from "../pages/usersManagement/usersManagementContainer";
import NoticeTypeContainer from "../pages/noticeType/noticeTypeContainer";
import LoginContainer from "../pages/authentication/loginContainer";
import CreateUserContainer from "../pages/createUser/createUserContainer";
import UpdateUserContainer from "../pages/updateUser/updateUserContainer";
import DriverMangmentContainer from "../pages/driverManagement/driverManagementContainer";
import NoticeManagementDetails from "../pages/noticeManagementDetails/noticeManagementDetailsContainer";
import NoticeManagementDetailsNew from "../pages/noticeManagementDetailsNew/noticeManagementDetailsNewContainer";
import CreateNoticeContainer from "../pages/createNotice/createNoticeContainer";

import Pages404 from "../pages/404/404";
import UpdateNoticeContainer from "../pages/updateNotice/updateNoticeContainer";



/**
 * An array of routes that are protected by authentication.
 * Each route object contains a path and an element/component to render when the path is matched.
 * @type {Array}
 * @property {string} path - The path of the route.
 * @property {ReactElement} element - The React element to render when the path is matched.
 * @property {boolean} [exact=false] - Whether the path should match exactly.
 * @property {ReactComponent} [component] - The React component to render when the path is matched.
 */
const authProtectedRoutes = [
  { path: "/usersManagement", element: <UsersManagementContainer /> },
  { path: "/depotsManagement", element: <DepotsManagementContainer /> },
  { path: "/noticeType", element: <NoticeTypeContainer /> },
  { path: "/noticemanagement", element: <NoticeManagementNewContainer /> },
  // { path: "/noticemanagement", element: <NoticeManagementContainer /> },
  // { path: "/noticemanagementnew", element: <NoticeManagementNewContainer /> },
  { path: "/usersManagement/createUser", element: <CreateUserContainer /> },
  { path: "/usersManagement/updateuser", element: <UpdateUserContainer /> },
  // { path: "/noticemanagement/noticeDetails", element: <NoticeManagementDetails /> },
  { path: "/noticemanagement/noticeDetails", element: <NoticeManagementDetailsNew /> },
  { path: "/noticemanagement/noticeDetailsnew", element: <NoticeManagementDetailsNew /> },
  { path: "/noticemanagement/createnotice", element: <CreateNoticeContainer /> },
  { path: "/noticemanagement/editnotice", element: <UpdateNoticeContainer /> },
];


const mangerProtectedRoutes = [
  { path: "/noticemanagement", element: <NoticeManagementNewContainer /> },
  // { path: "/noticemanagement", element: <NoticeManagementContainer /> },
  // { path: "/noticemanagementnew", element: <NoticeManagementNewContainer /> },
  { path: "/drivermangment", element: <DriverMangmentContainer /> },
  { path: "/noticemanagement/noticeDetails", element: <NoticeManagementDetailsNew /> },
  // { path: "/noticemanagement/noticeDetails", element: <NoticeManagementDetails /> },
  { path: "/noticemanagement/createnotice", element: <CreateNoticeContainer /> },
  { path: "/noticemanagement/editnotice", element: <UpdateNoticeContainer /> },
];




/**
 * An array of public routes that are accessible to all users.
 * Each route object contains a path and an element component.
 * @type {Array<{ path: string, element: React.Component }>}
 */
const publicRoutes = [
  { path: "/", element: <LoginContainer /> },
  { path: "/*", element: <Pages404 /> },
];

export { authProtectedRoutes, publicRoutes, mangerProtectedRoutes };
